<div class="container-fluid py-4" id="print-section">
  <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
    <thead>
      <tr>
        <th colspan="2" style="border: 1px solid black; padding: 8px; font-weight: bold; text-align: center;">Vivek Saptahik</th>
        <th colspan="6" style="border: 1px solid black; padding: 8px; font-weight: bold; text-align: center;">Issue Seller Credit Note Register</th>
      </tr>
      <tr>
        <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">Monthwise</th>
        <th colspan="6" style="border: 1px solid black; padding: 6px; text-align: center;">
          Date From: {{startDate | date: 'dd-MM-yyyy'}} To: {{endDate | date: 'dd-MM-yyyy'}}
        </th>
      </tr>
      <tr>
        <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">Month</th>
        <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">अंक परत</th>
        <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">अंक गहाळ/खराब</th>
        <th colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">Total</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let data of CreditNoteMFormBeans; let i = index">
        <td colspan="2" style="border: 1px solid black; padding: 6px; text-align: center; font-weight: 500;">
          {{data.month}} - {{data.year}}
        </td>
        <td colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">
          {{data.tds_amt}}
        </td>
        <td colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">
          {{data.other_credit_amt}}
        </td>
        <td colspan="2" style="border: 1px solid black; padding: 6px; text-align: center;">
          {{ (+data.tds_amt) + (+data.other_credit_amt) }}
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr>
        <td colspan="2" style="border: 1px solid black; padding: 8px; text-align: center; font-weight: bold;">Total:</td>
        <td colspan="2" style="border: 1px solid black; padding: 8px; text-align: center; font-weight: bold;">
          {{CreditadvtOffytdsMTotal}}
        </td>
        <td colspan="2" style="border: 1px solid black; padding: 8px; text-align: center; font-weight: bold;">
          {{CreditadvtOffotherMTotal}}
        </td>
        <td colspan="2" style="border: 1px solid black; padding: 8px; text-align: center; font-weight: bold;">
          {{CreditadvtOffMTotal}}
        </td>
      </tr>
    </tfoot>
  </table>

  <div class="noPrint mt-4 d-flex justify-content-end" style="gap: 16px; padding-right: 15%;">
    <button (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">ExportOff</button>
    <button mat-raised-button color="primary" [useExistingCss]="true" printSectionId="print-section" ngxPrint>Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
